<template>
  <div class="header">
<!--   pc -->
    <div class="nav" :style="{background: rgba}" v-if="isShow">
      <div class="nav_maxwidth">
        <img src="@/assets/headerImages/LOGO.png" alt="">
        <ul class="nav_switch">
          <li v-for="nav in navSwitch" :key="nav.id"><a :class="{'active':linkClass === nav.activeClass}" class="router_link_active" :href="nav.path" target="">{{nav.title}}</a></li>
        </ul>
      </div>
    </div>
<!--  移动  -->
    <div class="nav1" v-if="!isShow" style="background: #000">
      <div class="nav_maxwidth1">
        <img src="../../assets/headerImages/LOGO.png" alt="">
        <button class="navbar-toggle" @click="navToggle()">
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
          <span class="icon-bar"></span>
        </button>
      </div>
      <ul id="nav_switch" class="nav_switch1" style="display: none">
        <li v-for="nav in navSwitch" @click="navToggle()" :key="nav.id" :style="{width:nav.width}"><a class="router_link_active1" :class="{'active':linkClass === nav.activeClass}" :href="nav.path">{{nav.title}}</a></li>
      </ul>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'headers',
  props: {
    linkClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      url: '',
      screenWidth: document.body.clientWidth,
      isShow: true,
      scrollTop: 0,
      rgba: 'rgba(0,0,0,.5)',
      navSwitch: [
        { id: 1, title: '首页', path: 'index.html', activeClass: 'index' },
        { id: 2, title: '关于我们', path: 'about.html', activeClass: 'about' },
        { id: 3, title: '业务板块', path: 'plate.html', activeClass: 'plate' },
        { id: 4, title: '下属企业', path: 'subordinate.html', activeClass: 'subordinate' },
        { id: 5, title: '客户案例', path: 'example.html', activeClass: 'example' },
        { id: 6, title: '新闻中心', path: 'journalism.html', activeClass: 'journalism' },
        { id: 7, title: '人才招聘', path: 'recruit.html', activeClass: 'recruit' },
        { id: 8, title: '联系我们', path: 'contact.html', activeClass: 'contact' }
      ]
    }
  },
  watch: {
    screenWidth (val) {
      // 监听变化
      this.screenWidth = val
      this.screenWidthChange()
    }
  },
  mounted () {
    const _this = this
    this.screenWidthChange()
    window.addEventListener('scroll', this.scroll)
    // 浏览器窗口尺寸变化时赋值
    window.addEventListener('resize', function () {
      return (() => {
        window.screenWidth = document.body.clientWidth
        _this.screenWidth = window.screenWidth
      })()
    })
  },
  methods: {
    // 判断滚动条位置头部导航变颜色
    scroll () {
      const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      scrollTop >= 800 ? this.rgba = '#000' : this.rgba = 'rgba(0,0,0,0.5)'
    },
    // 移动端点击显示隐藏导航
    navToggle () {
      $('#nav_switch').stop().slideToggle(200)
    },
    // 判断可是宽度是否大于768
    screenWidthChange () {
      if (this.screenWidth > 768) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
*{
  margin: 0;
  padding: 0;
}
ul,li,ol {
  list-style: none;
}
    .nav{
      width: 100%;
      height: 77px;
      position: fixed;
      top: 0;
      left: 0;
      z-index: 10000;
      .nav_maxwidth {
        width: 1200px;
        height: 100%;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .nav_switch {
          display: flex;
          li {
            cursor: pointer;
            text-align: center;
            padding: 0 20px;
            .router_link_active {
              display: block;
              height: 100%;
              line-height: 77px;
              color: #fff;
              font-size: 16px;
              &.active {
                color: #ebba71;
              }
              &:hover {
                color: #ebba71;
              }
              text-decoration: none;
            }
          }
        }
      }
    }
    @media screen and (max-width: 768px){
      .nav1{
        width: 100%;
        position: fixed;
        height: 1.2rem;
        top: 0;
        left: 0;
        z-index: 10000;
        .nav_maxwidth1 {
          width: 6.5rem;
          height: 100%;
          margin: auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            width: .86rem;
          }
          .navbar-toggle {
            position: relative;
            padding: .1rem .2rem;
            background-color: transparent;
            background-image: none;
            border: 1px solid #333;
            border-radius: 4px;
            &:hover {
              background-color: #333;
            }
            .icon-bar {
              display: block;
              width: .5rem;
              height: .02rem;
              margin: .1rem 0;
              border-radius: .02rem;
              background: #fff;
            }
          }
        }
        .nav_switch1 {
          display: block;
          background: #000;
          width: 100%;
          border-top: .01rem solid #333;
          li {
            cursor: pointer;
            width: 100%;
            text-align: center;
            .router_link_active1 {
              display: block;
              height: 100%;
              line-height: 1rem;
              width: 100%;
              color: #fff;
              font-size: 16px;
              &.active {
                color: #ebba71;
              }
              &:hover {
                color: #ebba71;
              }
              text-decoration: none;
            }
          }
        }
      }
    }

</style>
